import React from 'react';

export const HourModal = {
  title: 'Hour',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>0 to 23</b>
      </div>
      <br />
      <p>The Date and Time are given in Universal Coordinated Time (also known as Greenwich Mean Time). The local date may be one day different.</p>
    </div>
  ),
};
